<template>
  <form @submit.prevent="authenticateSocSecNr" autocomplete="off">
    <v-row no-gutters align="center" justify="space-between">
      <v-col>
        <span v-if="isCompany">{{ $t('companyText') }}</span>
        <span v-else>{{ $t('privateText') }}</span>
      </v-col>
      <v-col v-if="isCompany" cols="12" sm="6" md="3">
        <v-row no-gutters align="center">
          <v-col :class="{ 'px-6': $vuetify.breakpoint.mdAndUp, 'mr-3': $vuetify.breakpoint.smAndDown }">
            <v-text-field name="socSecNr"
                          class="color-grey--text"
                          solo
                          hide-details
                          flat
                          :label="$t('socSecNr')"
                          id="socSecNr"
                          v-model="socSecNr"
                          required></v-text-field>
          </v-col>
          <div class="pa-3">
            <v-btn tile depressed dark class="color-black" type="submit" :disabled="!isSSNValid || loading" :loading="loading">
              {{ $t('buttonText') }}
            </v-btn>
          </div>
        </v-row>
      </v-col>
      <v-col v-else cols="12" sm="6" md="3">
        <v-row no-gutters align="center">
          <div class="pa-3">
            <v-btn tile color="primary" @click="startAuthentication" :disabled="loading" :loading="loading">
              {{ $t('buttonTextStrong') }}
            </v-btn>
          </div>
        </v-row>
      </v-col>
    </v-row>
  </form>
</template>

<script>
  export default {
    data: function () {
      return {
        socSecNr: '',
        loading: false
      }
    },
    computed: {
      isSSNValid () {
        if (this.isCompany) {
          return true
        } else {
          let validation = /^(0[1-9]|[12]\d|3[01])(0[1-9]|1[0-2])([5-9]\d\+|\d\d[-U-Y]|[012]\d[A-F])\d{3}[\dA-Z]$/.test(this.socSecNr.toUpperCase())

          return validation
        }
      },
      isCompany () {
        var debtor = this.$store.getters.debtor
        if (debtor !== null) {
          return debtor.isCompany
        } else {
          return false
        }
      }
    },
    methods: {
      authenticateSocSecNr () {
        if (this.isSSNValid) {
          this.loading = true
          this.$store.dispatch('authenticateSocSecNr', { LoginType: 3, Identifier: this.socSecNr }).then(() => {
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
        }
      },
      startAuthentication() {
        this.loading = true
        this.$store.dispatch('getAuthenticationUrlForLogin').then(() => {
            this.loading = false
          }).catch(() => {
            this.loading = false
          })
      }
    }
  }
</script>

<i18n>
  {
  "fi": {
  "privateText": "Huom! Sinulla on palvelussa muitakin velkoja. Tunnistautumalla pankkitunnuksilla voit nähdä kokonaistilanteesi.",
  "companyText": "Olet kirjautuneena yksittäisen asian tietoihin. Syötä Y-tunnuksesi, niin näet kokonaistilanteesi.",
  "buttonText": "Tarkista",
  "buttonTextStrong": "Aloita tunnistautuminen"
  },
  "se": {
  "privateText": "Observera! Du har andra skulder i tjänsten. Genom att logga in med dina bankuppgifter kan du se din totala situation.",
  "companyText": "Du tittar på informationen om ett enskilt ärende. Ange ditt FO-nummer för att se din helhetssituation.",
  "buttonText": "Kontrollera",
  "buttonTextStrong": "Börja autentisering"
  },
  "en": {
  "privateText": "Please note! You have other debts in the service. By logging in with your bank credentials, you can see your overall situation.",
  "companyText": "You are viewing the details of a single case. Enter your business ID to see your overall situation.",
  "buttonText": "Check",
  "buttonTextStrong": "Begin authentication"
  }
  }
</i18n>
